import { useInfiniteQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import type {
  ContentSectionConfig,
  TopicContentsPage,
} from "../../@types/portalAluno";
import { PORTAL_TOPIC_PAGE_SIZE } from "../../config/portalAluno/constants";
import { getContentsByTag } from "../../services/portalAluno/tags/tagsService";
import type { ApplicationState } from "../../store";

export const portalTagContentsQueryKey = (
  idUsuario?: number,
  kind?: string,
  tag?: string | null
) => ["portal-aluno", "tag-conteudos", idUsuario, kind, tag];

const useTagContents = (
  section?: ContentSectionConfig,
  tag?: string | null
) => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useInfiniteQuery<TopicContentsPage>({
    enabled: Boolean(idUsuario && section?.tagFiltered && tag),
    queryKey: portalTagContentsQueryKey(idUsuario, section?.kind, tag),
    queryFn: ({ pageParam = 0 }) =>
      getContentsByTag(section as ContentSectionConfig, tag as string, pageParam),
    getNextPageParam: (lastPage, allPages) =>
      lastPage.itemCount < PORTAL_TOPIC_PAGE_SIZE
        ? undefined
        : allPages.length * PORTAL_TOPIC_PAGE_SIZE,
  });
};

export default useTagContents;
